export const updateJsonBuilder = (state) => ({
  ...state,
  appVersion: {
    androidStoreAppStableVersion: state.androidStoreAppStableVersion,
    appleStoreAppStableVersion: state.appleStoreAppStableVersion,
  },
});
